// Alpine.js 组件用于情人节 2026 页面
document.addEventListener("alpine:init", () => {
  Alpine.data("valentinesPage", (block4ElementIds, block5ElementIds) => ({
    leftSwiper: null,
    rightSwiper: null,
    block4ElementIds: block4ElementIds || "", // 存储 Block 4 的元素IDs
    block5ElementIds: block5ElementIds || "", // 存储 Block 5 的元素IDs

    init() {
      // 等待 DOM 准备就绪和 Swiper 库加载
      this.$nextTick(() => {
        // 等待 Swiper 可用
        if (typeof Swiper !== "undefined") {
          this.initSwipers();
        } else {
          // 如果 Swiper 使用 defer 加载，再等待一会儿
          setTimeout(() => {
            if (typeof Swiper !== "undefined") {
              this.initSwipers();
            }
          }, 100);
        }
      });

      // 初始化元素移动功能
      this.initBlock4ElementMover();
      this.initBlock5ElementMover();
    },

    initSwipers() {
      // 初始化左侧 Swiper
      const leftContainer = this.$refs.leftSwiper;
      if (leftContainer) {
        this.leftSwiper = new Swiper(leftContainer, {
          effect: "cards",
          grabCursor: true,
          cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 16,
          },
        });
      }

      // 初始化右侧 Swiper
      const rightContainer = this.$refs.rightSwiper;
      if (rightContainer) {
        this.rightSwiper = new Swiper(rightContainer, {
          effect: "cards",
          grabCursor: true,
          cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 16,
          },
        });
      }
    },

    initBlock4ElementMover() {
      // 获取目标容器
      const targetContainer = this.$refs.block4Container;
      if (!targetContainer) {
        return;
      }

      // 使用传入的参数获取配置的元素IDs
      const elementIdsConfig = this.block4ElementIds;

      if (!elementIdsConfig || elementIdsConfig.trim() === "") {
        return;
      }

      // 分割IDs（使用|作为分隔符）
      const elementIds = elementIdsConfig
        .split("|")
        .map((id) => id.trim())
        .filter((id) => id !== "");

      if (elementIds.length === 0) {
        return;
      }

      // 轮询查找元素
      let attempts = 0;
      const maxAttempts = 20;
      const pollInterval = 500; // 500ms

      const pollForElement = () => {
        attempts++;

        // 遍历所有配置的ID，查找第一个存在的元素
        for (let i = 0; i < elementIds.length; i++) {
          const element = document.getElementById(elementIds[i]);
          if (element) {
            // 找到元素，移动到目标容器
            targetContainer.appendChild(element);
            return; // 停止轮询
          }
        }

        // 如果还没找到且未达到最大尝试次数，继续轮询
        if (attempts < maxAttempts) {
          setTimeout(pollForElement, pollInterval);
        }
      };

      // 开始轮询
      pollForElement();
    },

    initBlock5ElementMover() {
      // 获取目标容器
      const targetContainer = this.$refs.block5Container;
      if (!targetContainer) {
        return;
      }

      // 使用传入的参数获取配置的元素IDs
      const elementIdsConfig = this.block5ElementIds;

      if (!elementIdsConfig || elementIdsConfig.trim() === "") {
        return;
      }

      // 分割IDs（使用|作为分隔符）
      const elementIds = elementIdsConfig
        .split("|")
        .map((id) => id.trim())
        .filter((id) => id !== "");

      if (elementIds.length === 0) {
        return;
      }

      // 轮询查找元素
      let attempts = 0;
      const maxAttempts = 20;
      const pollInterval = 500; // 500ms

      const pollForElement = () => {
        attempts++;

        // 遍历所有配置的ID，查找第一个存在的元素
        for (let i = 0; i < elementIds.length; i++) {
          const element = document.getElementById(elementIds[i]);
          if (element) {
            // 找到元素，移动到目标容器
            targetContainer.appendChild(element);
            return; // 停止轮询
          }
        }

        // 如果还没找到且未达到最大尝试次数，继续轮询
        if (attempts < maxAttempts) {
          setTimeout(pollForElement, pollInterval);
        }
      };

      // 开始轮询
      pollForElement();
    },

    scrollToBlock1() {
      // 使用 x-ref 获取目标元素
      const targetElement = this.$refs.block1Wrapper;
      if (!targetElement) {
        return;
      }

      // 计算头部元素的高度
      let headerHeight = 0;

      // 查找 announcement-bar
      const announcementBar = document.querySelector(".shopify-section.shopify-section-group-header-group.shopify-section--announcement-bar");
      if (announcementBar) {
        headerHeight += announcementBar.offsetHeight;
      }

      // 查找 header
      const header = document.querySelector(".shopify-section.shopify-section-group-header-group.shopify-section--header");
      if (header) {
        headerHeight += header.offsetHeight;
      }

      // 计算目标位置（元素顶部位置减去头部高度）
      const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;

      // 平滑滚动到目标位置
      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    },
  }));
});
